export default "__VITE_ASSET__CLIH2ks8__"